//const AddressBaseUrl = "http://192.168.0.10:11215";
const AddressBaseUrl = "http://localhost:11215";
export default AddressBaseUrl;
